var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"hide-footer":"","hide-header":"","centered":"","size":"xs","noFade":""},model:{value:(_vm.isShowModal),callback:function ($$v) {_vm.isShowModal=$$v},expression:"isShowModal"}},[_c('div',{staticClass:"body-exit text-center"},[_c('span',[_vm._v("กดอีกครั้งเพื่อออก")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }